module.exports = __webpack_public_path__ + "static/media/8.8b2cb5b1.png";